<script setup lang="ts">
import { $t } from '@/composables/translations/useTranslate.ts';
import { computed } from 'vue';
import { formatPrice } from '@/utils/formatting/currencyFormatter.ts';

interface Props {
  label?: string;
  price?: number;
  name: string;
  nameLabel?: string;
  showPriceLabel?: boolean;
  included: boolean;
  includedText?: string;
}

const props = withDefaults(defineProps<Props>(), {
  nameLabel: undefined,
  label: undefined,
  price: undefined,
  showPriceLabel: false,
  includedText: undefined,
});

const icon = computed(() => {
  return props.included ? 'icon-checkmark' : 'icon-x';
});

/**
 * Price column content: the "incl." text when provided, otherwise the formatted
 * price (kept with its sign so negative separate items render too), or empty.
 */
const priceDisplay = computed(() => {
  if (props.includedText) return props.includedText;
  if (typeof props.price === 'number' && props.price !== 0) {
    return formatPrice(props.price, true);
  }
  return '';
});
</script>

<template>
  <div class="flex flex-col mb-5">
    <div class="flex items-center">
      <div class="flex items-center w-[70%]">
        <i class="w-6 h-4 shrink-0 bg-black icon" :class="icon"></i>
        <p class="ml-4 text-body-large">{{ props.name }}</p>
      </div>
      <p class="w-[30%] text-right text-body">
        {{ props.label }}
        {{ priceDisplay }}
      </p>
    </div>

    <div v-if="props.nameLabel" class="flex w-full">
      <p class="w-[70%] pl-10 text-body-small">{{ props.nameLabel }}</p>
      <p v-if="props.showPriceLabel" class="w-[30%] text-right text-body-small">
        {{ $t('ibe.checkout.accommodation.price') }}
      </p>
    </div>

    <slot></slot>
  </div>
</template>
